import React, { useState, useEffect, useRef } from 'react';
import { Card, Form, Row, Col, Accordion } from 'react-bootstrap';
import { CompactPicker } from 'react-color';


const FooterEditor = ({ section, onChange, setEditingElement, Gid, editingElement }) => {
    const isFirstRender = useRef(true);
    const [activeKey, setActiveKey] = useState(['2']);
    const [imageLoaded, setImageLoaded] = useState(true);
    const editingTimeoutRef = useRef(null);
    const lastEditingElementRef = useRef(null);

    useEffect(() => {
        return () => {
            if (editingTimeoutRef.current) {
                clearTimeout(editingTimeoutRef.current);
            }
        };
    }, []);

    const initializeLayout = (data) => {
        const defaultLinks = [
            { label: 'facebook', check: true, url: '' },
            { label: 'twitter', check: true, url: '' },
            { label: 'youtube', check: true, url: '' },
            { label: 'whatsapp', check: false, url: '' },
            { label: 'instagram', check: false, url: '' },
            { label: 'linkedin', check: false, url: '' }
        ];

        return {
            ...data,
            // links: defaultLinks,

        };
    };

    const [formData, setFormData] = useState(initializeLayout(section));



    const handleLinkCheckboxChange = (index, isChecked) => {
        setFormData(prev => {
            const updatedLinks = [...prev.links];
            updatedLinks[index] = {
                ...updatedLinks[index],
                check: isChecked
            };

            const updated = {
                ...prev,
                links: updatedLinks
            };

            onChange && onChange(updated);
            return updated;
        });
        handleSetEditingElement(`social-${formData.links[index].label}`);
    };

    const handleLinkUrlChange = (index, newUrl) => {
        setFormData(prev => {
            const updatedLinks = [...prev.links];
            updatedLinks[index] = {
                ...updatedLinks[index],
                url: newUrl
            };

            const updated = {
                ...prev,
                links: updatedLinks
            };

            onChange && onChange(updated);
            return updated;
        });
        handleSetEditingElement(`social-${formData.links[index].label}`);
    };

    useEffect(() => {
        const handleImageLoad = () => {
            setImageLoaded(true);
        };

        const handleImageError = () => {
            setImageLoaded(false);
        };
        const imgElement = document.createElement("img");
        imgElement.onload = handleImageLoad;
        imgElement.onerror = handleImageError;
        imgElement.src = formData.image;

        return () => {
            imgElement.onload = null;
            imgElement.onerror = null;
        };
    }, [formData]);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        if (section._id && section._id !== formData._id) {
            setFormData(initializeLayout(section));
        }
    }, [section]);

    const handleSetEditingElement = (element) => {
        if (editingTimeoutRef.current) {
            clearTimeout(editingTimeoutRef.current);
            editingTimeoutRef.current = null;
        }
        lastEditingElementRef.current = element;
        setEditingElement(element);
    };

    const handleClearEditingElement = () => {
        if (editingTimeoutRef.current) {
            clearTimeout(editingTimeoutRef.current);
        }
        editingTimeoutRef.current = setTimeout(() => {
            if (editingElement === lastEditingElementRef.current) {
                setEditingElement(null);
            }
        }, 200);
    };

    const updateField = (field, value) => {
        setFormData((prev) => {
            const updated = { ...prev, [field]: value };
            onChange && onChange(updated);
            return updated;
        });
        handleSetEditingElement(field);
    };



    return (
        <div className='overflow-auto'>
            <div className="d-flex justify-content-between align-items-center w-100 pe-3">
                <div className='d-flex align-items-center'>
                    <div className='settingIcon'>
                        <i class="fas fa-map-marked-alt"></i>
                    </div>
                    <div>
                        <h6 className="mb-0">Footer Section Settings</h6>
                        <label className="text-muted fw-6">Configure your hero section appearance</label>
                    </div>
                </div>

                <div className="d-flex align-items-center">
                    <label className="me-2 mb-0">Active</label>
                    <label className="switch">
                        <input
                            className="form-control"
                            type="checkbox"
                            checked={formData.isactive}
                            onChange={(e) => updateField('isactive', e.target.checked)}
                        />
                        <span className="slider round"></span>
                    </label>
                </div>
            </div>
            <Card className='mt-3 border shadow-0 overflow-hidden '>
                <Accordion activeKey={activeKey} onSelect={(e) => setActiveKey(e)}>
                   
                    {/* Appearance Section */}
                    <Accordion.Item eventKey="3" className=" border-0">
                        <Accordion.Header className="p-0 bg-transparent border-bottom">
                            <Form.Label className="fw-bold mb-0 d-flex align-items-center"><i class="fas fa-palette me-2 text-warning"></i> Appearance</Form.Label>
                        </Accordion.Header>
                        <Accordion.Body className="p-0">
                            <Card className="border-0 shadow-sm">
                                <Card.Body>
                                    <Row>
                                        <Col sm={12} md={3}>
                                            <Form.Label className="fw-bold"
                                            >Background Color</Form.Label> 
                                        </Col>
                                        <Col sm={12} md={9}>
                                            <div>
                                                <Form.Group className="mb-3">
                                                    <CompactPicker
                                                        color={formData.backgroundcolor}
                                                        onChangeComplete={(color) => {
                                                            updateField('backgroundcolor', color.hex);
                                                            setEditingElement(null);
                                                        }}
                                                    />
                                                </Form.Group>
                                            </div>
                                        </Col>

                                        <Col sm={12} md={3}>
                                            <Form.Label className="fw-bold"
                                            >Color</Form.Label>
                                        </Col>
                                        <Col sm={12} md={9}>
                                            <div>
                                                <Form.Group className="mb-3">
                                                    <CompactPicker
                                                        color={formData.color}
                                                        onChangeComplete={(color) => {
                                                            updateField('color', color.hex);
                                                            setEditingElement(null);
                                                        }}
                                                    />
                                                </Form.Group>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Accordion.Body>
                    </Accordion.Item>

                    {/* Social Media Links Section */}
                    <Accordion.Item eventKey="4" className=" border-0">
                        <Accordion.Header className="p-0 bg-transparent border-bottom">
                            <Form.Label className="fw-bold mb-0 d-flex align-items-center"><i class="fas fa-link me-2 text-primary"></i> Social Media Links</Form.Label>
                        </Accordion.Header>
                        <Accordion.Body className="p-0">
                            <Card className="border-0 shadow-sm">
                                <Card.Body>
                                    <Form.Group className="mb-3">
                                        <Form.Label className='fw-bold'>Follow us on</Form.Label>
                                        <div className="mt-3">
                                            {formData.links?.map((link, index) => (
                                                <div
                                                    key={index}
                                                    className="mb-3 d-flex align-items-center"
                                                    style={{
                                                        borderBottom: '1px solid #eee',
                                                        paddingBottom: '10px'
                                                    }}
                                                >
                                                    <Form.Check
                                                        type="checkbox"
                                                        id={`link-${index}-checkbox`}
                                                        checked={link?.check || false}
                                                        onChange={(e) => handleLinkCheckboxChange(index, e.target.checked)}
                                                        className="me-3"
                                                        style={{ minWidth: '20px' }}
                                                    />

                                                    <div className="d-flex align-items-center me-3" style={{ minWidth: '100px' }}>
                                                        <i className={`fab fa-${link?.label} me-2 text-secondary`}></i>
                                                        <span>{link?.label?.charAt(0).toUpperCase() + link?.label?.slice(1)}</span>
                                                    </div>

                                                    <Form.Control
                                                        type={link.label === 'whatsapp' ? 'tel' : 'url'}
                                                        placeholder={
                                                            link.label === 'whatsapp' ?
                                                                'Enter your phone number here' :
                                                                'Enter the page URL here'
                                                        }
                                                        value={link.url || ''}
                                                        onChange={(e) => handleLinkUrlChange(index, e.target.value)}
                                                        className={`${editingElement === `social-${link?.label}` ? 'element-highlight' : ''}`}
                                                        onFocus={() => handleSetEditingElement(`social-${link?.label}`)}
                                                        onBlur={handleClearEditingElement}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </Form.Group>
                                </Card.Body>
                            </Card>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Card>
        </div>
    );
};

export default FooterEditor;